export default __webpack_public_path__ + "static/media/NotoSansKR-Black.90d55574.woff2";